<template>
	<div class="hd-moa-frame-human-organs">
		<div class="hd-moa-frame-human-organs__human js-moa-frame-human-organs">
			<base-image-svg
				class="hd-moa-frame-human-organs__svg"
				:source="require('!html-loader!../../assets/svgs/04-moa-frame-human-organs.svg')"
			/>
			<base-image-svg
				class="hd-moa-frame-human-organs__svg hd-moa-frame-human-organs__svg--mobile"
				:source="require('!html-loader!../../assets/svgs/04-moa-frame-human-organs-mobile.svg')"
			/>
		</div>
	</div>
</template>

<style lang="scss" scoped>
	.hd-moa-frame-human-organs {
		position: absolute;
		@include box(100%);
		display: flex;
		align-items: flex-end;

		&__svg {
			&--mobile.hd-base-image-svg {
				display: none;
			}
		}

		&__human {
			width: 600px;
			height: 80%;

			:deep() svg {
				@include box(100%);

				#human-body {
					@include fade-out();
					transform: translateY(20%);
				}
				
				#gi-organs {
					@include fade-out();
					transform: translateY(20%);
				}

				#respiratory {
					@include fade-out();
					transform: translateX(10%);
				}

				#human-body-labels {
					@include fade-out();
				}
			}

			// Animations 
			&[data-state="animation-ready"] {
				:deep() svg {
					#human-body {
						@include animation-frame-enter-downwards();
					}

					#gi-organs, #respiratory {
						@include transition-frame-fade-in();
					}
					#human-body-labels {
						opacity: 1;
						transition-delay: 0.25s;
					}
				}
			}

			// Responsive 
			@include res-screen-small {
				:deep() svg {
					width: 460px;
					height: 55%;
				}
			}

			@include res-screen-x-small {
				:deep() svg {
					width: 400px;
					height: 50%;
				}
			}

			@include res-screen-portrait {
				@include center-x();
				top: 50px;
				margin-left: 60px;
				:deep() svg {
					max-width: 480px;
				}
			}

			@include res-screen-portrait-sm {
				@include center-x();
				margin-left: -40px;
				:deep() svg {
					max-width: 300px;
				}
			}
		}

		@include res-screen-portrait-sm {
			top: 60%;
			&__svg {
				display: none;

				&--mobile.hd-base-image-svg {
					display: flex;
				}
			}
		}
	}
</style>